import { FiverrContext } from '@fiverr-private/fiverr_context';

interface ComponentContext {
    currency: {
        name: string;
        rate: number;
        template: string;
        forceRound: boolean;
        forceRoundFromAmount: number;
        symbol: string;
    };
    pageCtxId: string;
    userId: number;
    queryParameters: Record<string, string>;
    sourcePage: string;
    viewportType: string;
    sourceComponent: string;
    currentPage: string;
}

export const ComponentName = {
    RECENTLY_SAVED_SELLERS: 'recently_saved_sellers',
    YOUR_RECENTLY_VIEWED_SELLERS: 'your_recently_viewed_sellers',
    JOB_POST_ADAPTIVE_SELLERS: 'job_post_adaptive_sellers',
    BUY_IT_AGAIN_SELLERS: 'by_buy_it_again',
    LAST_SEARCH_SELLERS: 'last_search_sellers',
} as const;

export type ComponentNameType = (typeof ComponentName)[keyof typeof ComponentName] | (string & {});

export interface Component {
    componentTitle: string;
    uuid: string;
    type: string;
    type_web: string;
    type_mobile_web: string;
    name: ComponentNameType;
    position: number;
    properties: Record<string, any> & { componentTitle: string };
    contextEnrichment: {
        impressionEnrichment: Record<string, any>;
        context: ComponentContext;
        isTouch: boolean;
    };
    items: Record<string, any>;
}

export interface PersonalizedComponentProps {
    component: Component;
    abTests?: FiverrContext['abTests'];
    placeholder?: React.ReactElement;
    sectionName?: string;
    isLoading?: boolean;
    showTranslatedUGC?: boolean;
    collectProps?: Record<string, any>;
    features?: Record<string, any>;
    biParams?: Record<string, any>;
    extraParams?: Record<string, any>;
    rollouts?: Record<string, boolean>;
    onCardImpression?: (eventData) => void;
}
